import { BrowserRouter } from 'react-router-dom';
import Routers from './Routers';
import './styles/global.scss';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routers />
    </BrowserRouter>
  );
}

export default App;
